import { render } from "./AdministrationMain.vue?vue&type=template&id=e56384f0&scoped=true"
import script from "./AdministrationMain.vue?vue&type=script&lang=js"
export * from "./AdministrationMain.vue?vue&type=script&lang=js"

import "./AdministrationMain.vue?vue&type=style&index=0&id=e56384f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e56384f0"]])

export default __exports__